@if (!siteHasSingleRestaurant) {
  <div class="dialog-title"
    mat-dialog-title
    >
    {{ ( 'MENU.CHANGE_RESTAURANT.TITLE' | transloco) }}
  </div>
}

<mat-dialog-content>

  @if (siteHasSingleRestaurant) {
    <p>{{ 'MENU.CHANGE_RESTAURANT.PROMPT_CHANGE_SITE' | transloco }}</p>
  } @else {
    <mat-action-list>
      <!-- SITE RESTAURANTS -->
      @for (restaurant of data.site.restaurants; track restaurant) {
        <button
          mat-list-item
          (click)="onGotoRestaurant(restaurant)">
          <div class="restaurant-result-item flex-row justify-start align-center gap-10">
            <mat-icon class="restaurant-icon"
            [color]="(restaurant.restaurantId === currentRestaurant.restaurantId)? 'accent' : 'primary'">location_on</mat-icon>
            <div class="restaurant-infos flex-column">
              <div class="restaurant-name">{{ restaurant.name }}</div>
              <div class="restaurant-address">{{ restaurant.address }}</div>
            </div>
          </div>
        </button>
      }
      <!-- SELECT OTHER SITE -->
      <button mat-list-item
        (click)="onGotoSiteSelection()">
        <div class="restaurant-result-item flex-row justify-start align-center gap-10">
          <mat-icon class="restaurant-icon"
          color="primary">my_location</mat-icon>
          <div class="restaurant-infos flex-column">
            <span>{{ 'MENU.CHANGE_RESTAURANT.CHANGE_SITE_OPTION' | transloco }}</span>
          </div>
        </div>
      </button>
    </mat-action-list>
  }

</mat-dialog-content>

<mat-dialog-actions>

  <button class="dialog-action-button"
    mat-button
    color="accent"
    (click)="onCancelClick()"
    cdkFocusInitial>
    {{ 'COMMON.CANCEL' | transloco }}
  </button>
  @if (siteHasSingleRestaurant) {
    <button class="dialog-action-button"
      mat-button
      color="primary"
      (click)="onGotoSiteSelection()">
      {{ 'COMMON.YES' | transloco }}
    </button>
  }

</mat-dialog-actions>
